<template>
<FilterMe @onSubmit="filterMe" @onClear="clear" :filters="filters">
    <template #form="{filters}">
        <CRow>
            <CCol col="12">
                <CInput v-model="filters.id" :placeholder="$t('user.id')" />
            </CCol>
            <CCol col="12">
                <CInput v-model="filters.full_name" :placeholder="$t('user.full_name')" />
            </CCol>
            <CCol col="12">
                <CInput v-model="filters.email" :placeholder="$t('user.email')" />
            </CCol>
            <CCol col="12">
                <CInput v-model="filters.phone" :placeholder="$t('user.phone')" />
            </CCol>
            <!-- <CCol col="12">
                <CInput type="number" v-model="filters.min_wallet" :placeholder="$t('user.balance')" />
            </CCol> -->
            <!-- <CCol col="12">
                <CInput type="number" v-model="filters.min_wage" :placeholder="$t('user.wage')" />
            </CCol> -->
            <CCol col="12">
                <CSelect2 v-model="filters.role.id" :options="selectableRolesWithNullStart" ignoreOptionStyle/>
            </CCol>
            <CCol col="12">
                <CSelect2 v-model="filters.activity_status" :options="statuses"/>
            </CCol>
            <CCol col="12">
                <CSelect2 v-model="filters.setup_status" :options="UserSetupStatusOption"/>
            </CCol>
            <CCol col="12">
                <CSelect2 v-model="filters.responsible" :options="responsibles"/>
            </CCol>
            <CCol sm="12">
                <div role="group" class="form-group datepicker">
                    <datePicker
                        :placeholder="$t('attributes.created_from')"
                        :clearable="true"
                        format="YYYY-MM-DD HH:mm:ss"
                        display-format="dddd jDD jMMMM jYYYY"
                        input-class="form-control"
                        v-model="filters.min_created_at"
                        type="datetime"
                    />
                </div>
            </CCol>

            <CCol sm="12">
                <div role="group" class="form-group datepicker">
                    <datePicker
                        :placeholder="$t('attributes.created_to')"
                        :clearable="true"
                        format="YYYY-MM-DD HH:mm:ss"
                        display-format="dddd jDD jMMMM jYYYY"
                        input-class="form-control"
                        v-model="filters.max_created_at"
                        type="datetime"
                    />
                </div>
            </CCol>

            <CCol sm="12" style="min-height: 250px;">
                <VueTagsInput
                    class="tag-filter-it"
                    autocomplete-always-open
                    :autocomplete-items="filteredStoreTags"
                    placeholder="علاقه‌مندی"
                    v-model="tag"
                    :tags="tags"
                    @tags-changed="newTags => filters.tags = newTags.map(tag => tag.text)"
                />
            </CCol>
        </CRow>
    </template>
</FilterMe>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { userStatusOption, UserSetupStatusOption } from '@/common/data'
import VueTagsInput from '@johmun/vue-tags-input'

export default {
    name: 'FilterIt',

    components: {
        VueTagsInput,
    },

    data() {
        return {
            userStatusOption,
            UserSetupStatusOption: [
                {
                    label: 'وضعیت راه‌اندازی',
                    value: ''
                },
                ...UserSetupStatusOption,
            ],
            filters: {
                id: '',
                full_name: '',
                email: '',
                username: '',
                phone: '',
                // min_wage: '',
                min_wallet: '',
                role: {
                    id: ''
                },
                // status: '',
                min_created_at: '',
                max_created_at: '',
                tags: [],
                responsible: ''
            },
            tag: '',
            tags: [],
        }
    },

    computed: {
        ...mapGetters({
            selectableRolesWithNullStart: 'role/selectableRolesWithNullStart',
            storeTags: 'store/tagsInput',
        }),
        filteredStoreTags() {
            return this.storeTags.filter(i => {
                return i.text.toLowerCase().indexOf(this.tag.toLowerCase()) !== -1
            })
        },
        statuses() {
            return [
                {
                    label: 'وضعیت',
                    value:''
                },
                {
                    label: 'فعال',
                    value: 'فعال'
                },
                {
                    label: 'غیرفعال',
                    value: 'غیرفعال'
                },
                {
                    label: 'معلق',
                    value: 'معلق'
                },
                {
                    label: 'ثبت‌نام اشتباه',
                    value: 'ثبت‌نام اشتباه'
                },
                {
                    label: 'منصرف شده',
                    value: 'منصرف شده'
                },
            ]
        },
        responsibles() {
            return [
                {
                    label: 'مسئول',
                    value:''
                },
                {
                    label: 'داود سرائی',
                    value: 'داود سرائی'
                },
                {
                    label: 'سینا عبداللهی',
                    value: 'سینا عبداللهی'
                },
                {
                    label: 'فاطمه خانجانی',
                    value: 'فاطمه خانجانی'
                },
            ]
        }
    },

    methods: {
        ...mapActions({
            fetch: 'user/fetch'
        }),
        filterMe(filters) {
            this.fetch({
                page: 1,
                ...filters
            })
        },
        clear() {
            this.tags = []
        }
    }
}
</script>

<style lang="scss" scoped>
::v-deep.tag-filter-it .ti-autocomplete {
    z-index: 0;
}
::v-deep.tag-filter-it {
    min-height: 300px;
}
</style>